class TabsMobile extends HTMLElement {
  constructor() {
    super();
    this.getAllNavigate = this.querySelectorAll('div.tab-mobile .tab-mobile-navigate');
    console.log(this.getAllNavigate, 10)
    this.getAllMobileText = this.querySelectorAll('.tab-mobile-text')
    this.getAllNavigate.forEach((nav) => {
      nav.addEventListener('click', () => {
        let isOpen = nav.nextElementSibling?.getAttribute('data-show') == 'true';
        this.toggle(isOpen, nav);
        console.log(3)

       // setTimeout(() => {
        //   this.scrollToElement(nav, 305, 150);
        // }, 305);
      })
    });

    this.removeEmptyTabs();
  }

  scrollToElement(element, duration, offset) {
    const targetOffset = element.offsetTop - offset;
    const initialOffset = window.scrollY;
    const distance = targetOffset - initialOffset;
    const startTime = performance.now();

    function scrollAnimation(currentTime) {
      const elapsedTime = currentTime - startTime;
      const progress = elapsedTime / duration;
      const newPosition = initialOffset + progress * distance;

      if ((window.scrollY >= targetOffset && distance > 0) || (window.scrollY <= targetOffset && distance < 0)) {
        return;
      }

      window.scrollTo({
        top: newPosition,
        behavior: 'smooth'
      });

      if (progress < 1) {
        requestAnimationFrame(scrollAnimation);
      }
    }

    requestAnimationFrame(scrollAnimation);
  }

  closeAll() {
    this.getAllNavigate.forEach(el => el.nextElementSibling.setAttribute('data-show', 'false'));
    this.getAllNavigate.forEach(el => {
      el.children[1].textContent = '+';
      el.setAttribute('data-show', 'false');
    });
  }

  toggle(isOpen, nav) {
    console.log("###")
    console.log(isOpen, nav)
    console.log(isOpen, nav)
    nav.setAttribute('data-show', isOpen ? 'false' : 'true');
    nav.nextElementSibling?.setAttribute('data-show', isOpen ? 'false' : 'true');
    //nav.querySelector("[data-indicator]")?.textContent = isOpen ? "+" : "-";
 }

  removeEmptyTabs() {
    this.getAllMobileText.forEach((el, i) => {
      if (el.textContent.trim().length == 0) {
        this.getAllNavigate[i].style.display = 'none';
      }
    })
  }
}

customElements.define('tabs-mobile', TabsMobile);